type isRowVisibleInViewportParams = {
  rowHeight: number;
  viewportHeight: number;
  rowContainerOffsetTop: number; // top Y cord of the parent container, if it's not at top: 0;
  rowTopPosition: number; // top Y cord of the current row
  scrollPosition: number; // the Y cord of the scroll
};

export const shouldKeepRowInVirtualList = ({
  rowHeight,
  viewportHeight,
  rowContainerOffsetTop,
  rowTopPosition,
  scrollPosition,
}: isRowVisibleInViewportParams) => {
  const topPadding = viewportHeight; // push top threshold up by one additional viewport
  const bottomPadding = viewportHeight * 2; // push bottom threshold down by one additional viewport

  const topViewportThreshold = scrollPosition - rowContainerOffsetTop - topPadding;
  const bottomViewportThreshold = scrollPosition - rowContainerOffsetTop + bottomPadding;

  const isRowBelowViewportTop = rowTopPosition + rowHeight > topViewportThreshold;
  const isRowAboveViewportBottom = rowTopPosition < bottomViewportThreshold;

  return isRowBelowViewportTop && isRowAboveViewportBottom;
};
